import SearchableSelect from "components/SearchableSelect/SearchableSelect";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function TestComponents() {
  /* ******************** All States ************************* */

  /* ******************** All Functions ************************* */
  // const searchFunction = async (searchText,page,limit) => {
  //   // Simulate an API call with a delay
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const sampleData = [
  //         "Apple",
  //         "Banana",
  //         "Orange",
  //         "Grapes",
  //         "Pineapple",
  //         "Mango",
  //         "Strawberry",
  //       ];
  //       const results = sampleData.filter((item) =>
  //         item.toLowerCase().includes(searchText.toLowerCase())
  //       );
  //       resolve({ results, total: results.length });
  //     }, 2000);
  //   });
  // };

  const searchFunction = async (searchText, page, limit) => {
    try {
      // const { data } = await API.post(
      //   "/manufacturer/shipments?page=" + page + "&limit=" + limit,
      //   {
      //     query: searchText,
      //     // filterBy:
      //     //   searchText && searchText !== "" ? filterBy.value : undefined,
      //     // ...dateFilters,
      //   },
      //   { headers: authHeader() }
      // );
      // return { results: data.data, total: data.total };

      let body = {
        query: searchText,
        page: page,
        limit: limit,
        activeTab: "all",
      };

      const { data } = await API.post("/work-orders", body, {
        headers: authHeader(),
      });
      return {
        results: data.result || [],
        total: data.total || 0,
        totalPages: data.totalPages || 0,
      };
    } catch (error) {
      console.error("Error fetching search results:", error);
      return { results: [], total: 0, totalPages: 0 };
    }
  };

  /* ******************** All UseEffects ************************* */

  /* ******************** Custom Components ************************* */

  return (
    <div
      style={{
        marginLeft: 260,
      }}
      className="p-2"
    >
      <h3>Searchable Select</h3>
      <div className="w-25">
        <SearchableSelect
          searchFunction={searchFunction}
          RenderItem={({ item, index }) => (
            <>
              <div className="px-3 py-1 m-1 rounded-3 bg-light">
                {item.jobName}
              </div>
            </>
          )}
        />
      </div>
      <hr />
    </div>
  );
}
